import Icon from '../components/Icon';

const Pub = Icon(
  'pub',
  <>
    <path d="M1 2.75A.75.75 0 0 1 1.75 2h20.5a.75.75 0 0 1 0 1.5H17.5V5H16V3.5H8V5H6.5V3.5H1.75A.75.75 0 0 1 1 2.75" />
    <path
      fillRule="evenodd"
      d="M15.5 9.75a1 1 0 0 0-1-1H9.422a1 1 0 0 0-1 1v2.042c0 .751.161 1.299.44 1.926q.117.259.246.51c.089.18.178.358.258.541.143.326.222.602.222.861v2.256a.625.625 0 0 0 .665.623l.034.002h3.422a.62.62 0 0 0 .625-.625V15.63c0-.26.08-.535.222-.86.08-.184.169-.363.258-.541q.128-.253.245-.51c.28-.628.441-1.176.441-1.927zm-2.416 5.88v1.63h-2.246v-1.63c0-.51-.156-.97-.326-1.36-.08-.185-.17-.365-.26-.545q-.13-.254-.247-.513v-.001a5 5 0 0 1-.182-.461h4.276a5 5 0 0 1-.182.46v.002q-.118.26-.247.514c-.09.18-.18.359-.26.543-.17.39-.326.85-.326 1.361M14.25 10v1.5H9.672V10z"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M4 6.75c0-.69.56-1.25 1.25-1.25h13.5c.69 0 1.25.56 1.25 1.25v10.558a2.25 2.25 0 0 1-1.272 2.027l-5.75 2.776a2.25 2.25 0 0 1-1.956 0l-5.75-2.776A2.25 2.25 0 0 1 4 17.308zM5.5 7v10.308c0 .288.165.55.424.676l5.75 2.776c.206.1.446.1.652 0l5.75-2.776a.75.75 0 0 0 .424-.676V7z"
      clipRule="evenodd"
    />
  </>
);

export default Pub;
